/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { Input2, DropDown2, DecimalInput } from "components";
import { useInput } from "hooks";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveCreditCard2TextBuilder = ({
  className,
  value = "",
  onChange = () => {},
}) => {
  const start = useInput("10.00");
  const end = useInput("");

  const type = useInput("$");

  const typeData = [
    {
      id: "$",
      title: "$",
    },
    { id: "%", title: "%" },
  ];

  const formatValue = (s, e, t) => {
    if (!s) return "";
    return t === "$"
      ? `$${formatDollarValue(s)}${e ? `-$${formatDollarValue(e)}` : ""}`
      : `${s}${t}${e ? `-${e}${t}` : ""}`;
  };

  const handleUpdateValue = (s, e, t) => {
    onChange(`Save ${formatValue(s, e, t)} w/store credit card`);
  };

  useEffect(() => {
    if (value.endsWith("w/store credit card") && value.startsWith("Save")) {
      let main = value.slice(0, -19).trim();
      main = main.slice(4).trim();
      if (main.startsWith("$")) {
        type.setValue("$");
        const parts = main.split("-");
        start.setValue(parts[0].replace("$", "").trim());
        end.setValue(parts[1] ? parts[1].replace("$", "").trim() : "");
      } else {
        type.setValue("%");
        const parts = main.split("-");
        start.setValue(parts[0].replace("%", "").trim());
        end.setValue(parts[1] ? parts[1].replace("%", "").trim() : "");
      }
    }
    return () => {};
  }, [value]);

  return (
    <div className={`${className} mt-1 py-2`}>
      <Title>Incentive Text Builder</Title>
      <Container className="mt-2">
        <div style={{ width: 100 }}>
          {type.value === "$" ? (
            <DecimalInput
              label="Start Value"
              value={start.value}
              onChange={(e) => {
                start.setValue(e);
                handleUpdateValue(e, end.value, type.value);
              }}
            />
          ) : (
            <Input2
              label="Start Value"
              value={start.value}
              type="float"
              onChange={(e) => {
                start.setValue(e);
                handleUpdateValue(e, end.value, type.value);
              }}
            />
          )}
        </div>
        <div className="mt-auto mb-1 px-2">-</div>
        <div style={{ width: 100 }}>
          {type.value === "$" ? (
            <DecimalInput
              label="End Value"
              value={end.value}
              onChange={(e) => {
                end.setValue(e);
                handleUpdateValue(start.value, e, type.value);
              }}
            />
          ) : (
            <Input2
              label="End Value"
              value={end.value}
              type="float"
              onChange={(e) => {
                end.setValue(e);
                handleUpdateValue(start.value, e, type.value);
              }}
            />
          )}
        </div>
        <div style={{ width: 120, marginLeft: 10 }}>
          <DropDown2
            label="Time"
            data={typeData}
            width={70}
            value={type.value}
            onChange={(e) => {
              const nextStart = e === "$" ? formatDollarValue(start.value) : start.value;
              const nextEnd = e === "$" ? formatDollarValue(end.value) : end.value;
              type.setValue(e);
              start.setValue(nextStart);
              end.setValue(nextEnd);
              handleUpdateValue(nextStart, nextEnd, e);
            }}
          />
        </div>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
